/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/Actions"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-AjnkD': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
{children}
</React.Fragment>)
}